// ─── Safe Storage ──────────────────────────────────────────────────────────
// localStorage/sessionStorage access can throw — not just QuotaExceededError on
// write, but a SecurityError on ANY access (including the plain property getter)
// in contexts like sandboxed iframes without allow-same-origin, some
// enterprise/kiosk browser lockdowns, and Safari with storage fully disabled.
// Every call site in this app should go through these wrappers instead of the
// Storage API directly, so a locked-down environment degrades one feature
// instead of crashing the page.

export function safeLocalGet(key: string): string | null {
  try { return localStorage.getItem(key) } catch { return null }
}
export function safeLocalSet(key: string, value: string): void {
  try { localStorage.setItem(key, value) } catch { /* storage disabled or full — ignore */ }
}
export function safeLocalRemove(key: string): void {
  try { localStorage.removeItem(key) } catch { /* ignore */ }
}

export function safeSessionGet(key: string): string | null {
  try { return sessionStorage.getItem(key) } catch { return null }
}
export function safeSessionSet(key: string, value: string): void {
  try { sessionStorage.setItem(key, value) } catch { /* storage disabled or full — ignore */ }
}
export function safeSessionRemove(key: string): void {
  try { sessionStorage.removeItem(key) } catch { /* ignore */ }
}
export function safeSessionClear(): void {
  try { sessionStorage.clear() } catch { /* ignore */ }
}
